import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

/**
 * Thin wrapper around `react-infinite-scroll-component` used across the app.
 * Keeps call-sites consistent and avoids re-implementing boilerplate.
 */
const InfiniteScrollPagination = ({
  dataLength,
  next,
  hasMore,
  loader,
  children,
  scrollableTarget,
  scrollThreshold = 0.9,
}) => {
  return (
    <InfiniteScroll
      dataLength={dataLength}
      next={next}
      hasMore={hasMore}
      loader={loader}
      scrollableTarget={scrollableTarget}
      scrollThreshold={scrollThreshold}
    >
      {children}
    </InfiniteScroll>
  )
}

export default InfiniteScrollPagination
